// this directive doesn't support nesting itself
// remember to have only one instance of it running at a time

import type { ObjectDirective } from 'vue'

const focusableElements = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'

type TrapFocusElement = HTMLElement & {
  onKeyDown?: (e: KeyboardEvent) => void
}

const directive: ObjectDirective<TrapFocusElement> = {
  beforeMount (el) {
    el.onKeyDown = (e: KeyboardEvent) => {
      if (el.offsetWidth > 0 && el.offsetHeight > 0) {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9

        if (!isTabPressed) return

        const focusableContent = [...el.querySelectorAll<HTMLElement>(focusableElements)]
          .filter(item => {
            return !item.hasAttribute('disabled')
          })
        const firstFocusableElement = focusableContent[0]
        const lastFocusableElement = focusableContent[focusableContent.length - 1]

        if (!firstFocusableElement || !lastFocusableElement) return

        if (!el.contains(document.activeElement) || document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus()
          e.preventDefault()
        } else if (e.shiftKey && document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus()
          e.preventDefault()
        }
      }
    }
    document.addEventListener('keydown', el.onKeyDown)
  },

  unmounted (el) {
    if (el.onKeyDown) {
      document.removeEventListener('keydown', el.onKeyDown)
    }
  },
}

export default directive
